const ScreenHeader = ({children}) => {
    return(
     <div className="border-b border-gray-700 pb-5 mb-5 mt-5">
         {children}
     </div>
    )
}
export default ScreenHeader;